import {
  CloudUpload,
  RecentActors,
  SvgIconComponent,
} from '@mui/icons-material';

export type ProfessionalToolCardConfig = {
  id: string;
  title: string;
  description: string;
  href: string;
  ctaLabel: string;
  Icon: SvgIconComponent;
  tracking?: {
    type: string;
  };
};

export const PROFESSIONAL_TOOL_CARDS: ProfessionalToolCardConfig[] = [
  {
    id: 'bulk-property-search',
    title: 'Bulk Property Search',
    description:
      'Upload addresses in bulk to search for property and ownership details and save them to a list automatically.',
    href: '/dashboard/import-list',
    ctaLabel: 'Upload Addresses',
    Icon: CloudUpload,
    tracking: {
      type: 'bulk_upload_cta',
    },
  },
  {
    id: 'contact-enrichment',
    title: 'Contact Enrichment',
    description:
      'Upload a contact list to search for missing names, addresses, phone numbers, and emails.',
    href: '/dashboard/contact-enrichment',
    ctaLabel: 'Upload Contacts',
    Icon: RecentActors,
    tracking: {
      type: 'contact_entrichment_cta',
    },
  },
];
